import * as React from "react";
import DropDown from "../../../hiberUiKit/src/molecules/DropDown/DropDown";
import {Option} from "ts-option";
import Col from "../../layout/Col";
import FormGroup from "../../../hiberUiKit/src/molecules/FormGroup/FormGroup";

interface ComponentProps {
	/**
	 * Update custom field value action.
	 * @param {string} updatedValue
	 */
	updateCustomFieldValue: (updatedValue: string) => void;
	/**
	 * Remove custom field value action.
	 */
	removeCustomFieldValue: () => void;
	/**
	 * Custom field values list
	 */
	items: string[]
	/**
	 * Custom field label
	 */
	label: string;
	/**
	 * Selected custom field value
	 */
	selectedValue: Option<string>;
}

export default class EnumInFormDisplay extends React.PureComponent<ComponentProps> {
	render() {
		return (
			<Col md={12} lg={4} xl={4} style={{paddingBottom: '30px'}}>
				<FormGroup label={this.props.label}>
					<DropDown items={this.props.items}
							  itemToId={(item: string) => item}
							  itemToLabel={(item: string) => item}
							  selectedItemId={this.props.selectedValue.orNull}
							  placeholder={'Please select'}
							  onSelect={this.onSelect}
							  clearable
							  onClearClick={this.onClearClick}/>
				</FormGroup>
			</Col>
		);
	}

	onSelect = (value: string) => {
		this.props.updateCustomFieldValue(value);
	};

	onClearClick = () => {
		this.props.removeCustomFieldValue();
	}
}